import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_c_table = _resolveComponent("c-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_c_search_list, {
      inputList: _ctx.inputList,
      showNumber: 5,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, null, 8, ["inputList", "onOnSearch", "onOnReset"]),
    _createVNode(_component_c_table, {
      class: "mt10",
      dataSource: _ctx.tableConfig,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange
    }, null, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"])
  ]))
}